import config from "@/config";
import http from "@/utils/request";

export default {
	base: {
		list: {
			url: `${config.API_URL}/ly/knowledge/base/page`,
			name: "知识库分页",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/ly/knowledge/base`,
			name: "知识库详情",
			get: async function (params) {
				return await http.get(`${this.url}/${params.id}`);
			},
		},
		updataStatus: {
			url: `${config.API_URL}/ly/knowledge/base`,
			name: "新增/编辑知识库",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		status: {
			url: `${config.API_URL}/ly/knowledge/base`,
			name: "修改状态",
			put: async function (params) {
				return await http.put(`${this.url}/${params.id}`);
			},
		},
		import: {
			url: `${config.API_URL}/ly/knowledge/base/import`,
			name: "导入知识库",
			post: async function (data, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		template: {
			url: `${config.API_URL}/ly/knowledge/base/template`,
			name: "获取模板",
			get: async function (params = {}, config = {}) {
				return await http.get(
					this.url,
					params,
					Object.assign({ responseType: "blob" }, config)
				);
			},
		},
		delete: {
			url: `${config.API_URL}/ly/knowledge/base`,
			name: "删除知识库",
			delete: async function (params) {
				return await http.delete(`${this.url}/${params.id}`);
			},
		},
	},
};
